import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

const renderHeadLine = (set) => {
  return (
    <Grid item xs={12} md={12}>
      <p className="origin_content_chapter">
        {set.title}
      </p>
    </Grid>
  );
};

const renderChapter = (chapter) => {
  const { contents } = chapter;
  return (
    <Grid item xs={12} md={Number(contents.grid_width)} key={chapter.id}>
      <a className="btn" href={contents.signature_url} target={contents.link_type} rel="noopener noreferrer">
        <span className="origin_content">
          <span className="chapter-name">
            {chapter.name}
          </span>
        </span>
      </a>
    </Grid>
  );
};

const ChapterHeading = (heading) => {
  const chapters = heading.chapters.map(chapter => renderChapter(chapter));
  return (
    <Grid container spacing={1} className="origin_content_box" key={heading.id}>
      {heading.title && renderHeadLine(heading)}
      {chapters}
    </Grid>
  );
};


const ChapterTitle = (attachment) => {
  const ChapterHeadings = attachment.headings.map(heading => ChapterHeading(heading));
  return (
    <div key={attachment.id}>
      <div className="headline">
        <p className="chap_title">
          {attachment.title}
        </p>
      </div>
      {ChapterHeadings}
    </div>
  );
};

const AttachmentEpisode = ({ episode }) => {
  const contents = episode.attachments ?
    episode.attachments.map(attachment => ChapterTitle(attachment)) : null;
  return (
    <section className="episode-origin" key={episode.episode_number}>
      <div className="container">
        {contents}
      </div>
    </section>
  );
};

AttachmentEpisode.propTypes = {
  episode: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AttachmentEpisode;
